// extracted by mini-css-extract-plugin
export default {"bg":"style_bg__8nlvA","r1":"style_r1__ZmPw0","r2":"style_r2__CQBp8","r3":"style_r3__FW6Ji","r4":"style_r4__J0NEC"};